
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/forms/form1";
const form1State = namespace("Form1");

@Component
export default class InitialDocumentsAppRightToAppealPg extends Vue { 
    
    @form1State.Action
    public UpdateCurrentNoticeOfAppealId!: (newCurrentNoticeOfAppealId: string) => void
    
    public startNewForm1Document(){
        this.UpdateCurrentNoticeOfAppealId(null)
        this.$router.push({name: "checklist-form1" })
    }

    public helpText(content: string){
        return {title: "<div style='margin: 0;'>" +content+ "</div>"};
    }

}
